import { render, staticRenderFns } from "./AddSortConditionBasedOnPopularity.vue?vue&type=template&id=18316106"
import script from "./AddSortConditionBasedOnPopularity.vue?vue&type=script&lang=ts"
export * from "./AddSortConditionBasedOnPopularity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports